import {
    $, addAction, addFilter, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    if ($('body').hasClass('page-header-overlay')) {
        addFilter('css-vars/register', (styles) => ({ ...styles, 'header-offset': '0px' }));
    }
}, 5);
